import React, { PropsWithChildren } from "react";

import classnames from "classnames";

import { StyledDialogTitle } from "./Styles";
import { Header3 } from "../Typography/Variants/Header3";
// import { useDialogContext } from "./DialogContext";

export interface DialogTitleProps {
  className?: string;
  disableDefaultHeading?: boolean;
}

export const DialogTitle = ({
  children,
  className,
  disableDefaultHeading = false,
  ...rest
}: PropsWithChildren<DialogTitleProps>) => {
  // useDialogContext();

  return (
    <StyledDialogTitle
      className={classnames("c-dialog-title-wrapper", className)}
      {...rest}
    >
      {disableDefaultHeading ? children : <Header3>{children}</Header3>}
    </StyledDialogTitle>
  );
};

DialogTitle.displayName = "DialogTitle";
